module.exports = __webpack_public_path__ + "static/media/as-the-seasons-we-change.0b493164.jpg";